<template>
  <div>
    <Layout/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idLocalidad" class="form-label">IdLocalidad</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idLocalidad" name="idLocalidad" v-model="datoLocalidad.idLocalidad" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idLocalidadSup" name="idLocalidadSup" v-model="datoLocalidad.idLocalidadSup"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idLocalidadSup" class="form-label"> Localidad Sup</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="localidadSup" name="localidadSup" v-model="datoLocalidad.localidadSup" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalLocalidadSupLOV"
                      title="Buscar ">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="codigo" class="form-label">Código</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="codigo" name="codigo" v-model="datoLocalidad.codigo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoLocalidad.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarLocalidad" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarLocalidad" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditLocalidad" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdEmpresa</th>
          <th scope="col">IdLocalidad</th>
          <th scope="col">IdTipoIden</th>
          <th scope="col">Documento</th>
          <th scope="col">RazonSocial</th>
          <th scope="col">Nombre</th>
          <th scope="col">NombreCorto</th>
          <th scope="col">Direccion</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaAct</th>
          <th scope="col">IdUsuarioReg</th>
          <th scope="col">IdUsuarioAct</th>
          <th scope="col">Estado</th>
          <th scope="col">TipoIdenNombre</th>
          <th scope="col">LocalidadNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="empresa in datosPaginados" :key="empresa.idEmpresa">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(empresa.idEmpresa)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(empresa.idEmpresa)" title="Editar">edit_square</i></td>
          <td>{{empresa.idEmpresa}}</td>
          <td>{{empresa.idLocalidad}}</td>
          <td>{{empresa.idTipoIden}}</td>
          <td>{{empresa.documento}}</td>
          <td>{{empresa.razonSocial}}</td>
          <td>{{empresa.nombre}}</td>
          <td>{{empresa.nombreCorto}}</td>
          <td>{{empresa.direccion}}</td>
          <td>{{getFormattedDate(empresa.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(empresa.fechaAct, 'DD/MM/YYYY')}}</td>
          <td>{{empresa.idUsuarioReg}}</td>
          <td>{{empresa.idUsuarioAct}}</td>
          <td>{{empresa.estado}}</td>
          <td>{{empresa.tipoIdenNombre}}</td>
          <td>{{empresa.localidadNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteLocalidad(empresa.idEmpresa)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idEmpresa" class="form-label">IdEmpresa</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoEmpresa.idEmpresa" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idLocalidad" class="form-label">IdLocalidad</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idLocalidad" name="idLocalidad" v-model="datoEmpresa.idLocalidad" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idTipoIden" name="idTipoIden" v-model="datoEmpresa.idTipoIden"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idTipoIden" class="form-label"> Tipo Iden</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="tipoIden" name="tipoIden" v-model="datoEmpresa.tipoIden" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalTipoIdenLOV"
                      title="Buscar Tipos de Identificación">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="documento" class="form-label">Documento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="documento" name="documento" v-model="datoEmpresa.documento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="razonSocial" class="form-label">RazonSocial</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="razonSocial" name="razonSocial" v-model="datoEmpresa.razonSocial" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoEmpresa.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombreCorto" class="form-label">NombreCorto</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombreCorto" name="nombreCorto" v-model="datoEmpresa.nombreCorto" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="direccion" class="form-label">Dirección</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="direccion" name="direccion" v-model="datoEmpresa.direccion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoEmpresa.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoEmpresa.fechaAct" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoEmpresa.idUsuarioReg" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoEmpresa.idUsuarioAct" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarEmpresa" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditEmpresa" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!-- Lista de Valores: LocalidadSup -->
    <LocalidadSupLOV @DatosLocalidadSup="GetDataLocalidadSupLOV($event)"/>
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: Empresa -->
    <EmpresaLOVdet @DatosEmpresa="GetDataEmpresaLOVdet($event)"/>
<!-- Lista de Valores: TipoIden -->
    <TipoIdenLOVdet @DatosTipoIden="GetDataTipoIdenLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
// Listas de valores master
import LocalidadSupLOV from '../../components/lovs/LocalidadLOV.vue'
// Listas de valores master
// Listas de valores details
import EmpresaLOVdet from '../../components/lovs/EmpresaLOV.vue'
import TipoIdenLOVdet from '../../components/lovs/TipoIdenLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
, LocalidadSupLOV
// Listas de valores master
// Listas de valores details
, EmpresaLOVdet
, TipoIdenLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      localidads : [],
      datoLocalidad : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idLocalidad: '',
// Variables master
// Variables details
      empresas : [],
      datoEmpresa : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idLocalidad = this.$route.params.p_idlocalidad
    this.abrirEditar(this.p_idLocalidad)
    this.getEmpresas()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      if(this.datoLocalidad.idLocalidad === ''){
        swal("Error!", "El elemento idLocalidad no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoLocalidad.idLocalidadSup === ''){
        swal("Error!", "El elemento idLocalidadSup no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoLocalidad.codigo === ''){
        swal("Error!", "El elemento codigo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoLocalidad.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoLocalidad.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarLocalidad(){
      if(this.validarForm() === 1){
        try {
          await api.post('/localidads', this.datoLocalidad)
          swal("Correcto!", "Localidad creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditLocalidad(){
      if(this.validarForm() === 1){
        try {
          await api.post('/localidads', this.datoLocalidad)
          swal("Correcto!", "Localidad creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoLocalidad={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idLocalidad){
      this.modalWindow = true
      if(idLocalidad != null){    
           api.get('/vwlocalidads/'+idLocalidad).then(resp=>{
          this.datoLocalidad = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarLocalidad(){
      this.$router.push('/Localidad')
    },
// Procedimientos master
// Procedimientos detalle
    async getEmpresas() {
      const resp = await api.get('/empresas')
      this.empresas = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.empresas.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwempresas/nombre/'+this.nombreBusqueda).then(response=>{
          this.empresas=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.empresas.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwempresas').then(response=>{
      this.empresas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.empresas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoEmpresa.idLocalidad === ''){
        swal("Error!", "El elemento idLocalidad no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.idLocalidadSup === ''){
        swal("Error!", "El elemento idLocalidadSup no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.codigo === ''){
        swal("Error!", "El elemento codigo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEmpresa.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarEmpresa(){
      if(this.validarForm() === 1){
        try {
          this.datoEmpresa.idLocalidad = this.datoLocalidad.idLocalidad;
          await api.post('/empresas', this.datoEmpresa)
          this.getEmpresas();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Empresa creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditEmpresa(){
      if(this.validarForm() === 1){
        try {
          await api.post('/empresas', this.datoEmpresa)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Empresa creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoEmpresa={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idEmpresa){
      this.modalWindow = true
      if(idEmpresa != null){    
           api.get('/vwempresas/'+idEmpresa).then(resp=>{
          this.datoEmpresa = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idEmpresa){
      this.modalWindow = true
      if(idEmpresa != null){
        this.$router.push('/empresamd/'+idEmpresa)
      }
    },
    async deleteEmpresa (idEmpresa) {
      try{
        await api.delete('/empresas/'+idEmpresa)
          this.getEmpresas()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
//    Lista de Valores
    GetDataLocalidadSupLOV(data) {
      this.datoLocalidad.idLocalidadSup = data.idLocalidadSup;
      this.datoLocalidad.localidadSup = data.nombre;
    },
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataEmpresaLOVdet(data) {
      this.datoEmpresa.idEmpresa = data.idEmpresa;
      this.datoEmpresa.empresa = data.nombre;
    },
//    Lista de Valores
    GetDataTipoIdenLOVdet(data) {
      this.datoEmpresa.idTipoIden = data.idTipoIden;
      this.datoEmpresa.tipoIden = data.nombre;
    },
// Listas de valores details
  },
}
</script>
